import { Badge } from "primereact/badge";
import { Menu } from "primereact/menu";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import LinkWithIcon from "../../../components/LinkWithIcon";
import { LeftPageIndicator } from "../../../constant";
import NotificationSection from "../../../components/NotificationSection";
import useApi from "../../../useApi";

import {
  BellIcon,
  CheveronDown,
  EditUserIcon,
  LogoutIcon,
  user,
} from "../../../constant";
import LogoutModal from "../../../modals/Logout";
import classes from "./Navbar.module.css";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { logout } from "../../../store/authSlice";
const options = [
  { label: "Bookings", value: "bookings" },
  { label: "Bookings", value: "bookings" },
  { label: "Bookings", value: "bookings" },
  { label: "Bookings", value: "bookings" },
  { label: "Bookings", value: "bookings" },
  { label: "Bookings", value: "bookings" },
];
const itemRenderer = (item) => (
  <div className="p-menuitem-content">
    <a className="flex align-items-center p-menuitem-link" href={item.url}>
      <span className={item.icon} />
      <span className="mx-2">{item.label}</span>
      {item.badge && <Badge className="ml-auto" value={item.badge} />}
      {item.shortcut && (
        <span className="ml-auto border-1 surface-border border-round surface-100 text-xs p-1">
          {item.shortcut}
        </span>
      )}
    </a>
  </div>
);
const items = ({ auth, navigate, setShowLogoutModal }) => [
  {
    command: () => {
      navigate("/profile");
    },
    template: (item, options) => (
      <LinkWithIcon
        label={"Profile"}
        options={options}
        onClick={(e) => options.onClick(e)}
        icon={<EditUserIcon />}
      />
    ),
  },

  {
    separator: true,
  },
  {
    command: () => {
      setShowLogoutModal(true);
    },
    template: (item, options) => {
      return (
        <LinkWithIcon
          label={"Logout"}
          labelClass={classes.logout}
          options={options}
          onClick={(e) => options.onClick(e)}
          icon={<LogoutIcon />}
        />
      );
    },
  },
];

const Navbar = () => {
  const { fcmToken } = useSelector((state) => state?.auth);

  const { getNotifications } = useApi();
  const api = useApi();
  const dispatch = useDispatch();
  const { link, title } = useSelector((state) => state?.page);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const menu = useRef(null);
  const navigate = useNavigate();
  const { auth } = useSelector((state) => state);
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(false);
  const handleCloseNotification = () => {
    setShowNotification(false);
  };

  const logoutHandler = async () => {
    setLoading(true);
    console.log("FCM TOKEN", fcmToken);
    const response = await api.logoutApi({
      deviceToken: fcmToken,
    });
    console.log("Response", response);
    if (response?.data?.headers?.error == 200) {
      dispatch(logout());
      toast.success("Logout Successfully");
    } else {
      toast.error(response.data?.headers?.message);
    }

    setLoading(false);
  };

  useEffect(() => {
    if (showNotification) {
      getNotificationsApi({
        id: null,
        search: "",
        pageNumber: 1,
        pageSize: 10,
        showInactive: true,
        showUpcoming: true,
      });
    }
  }, [showNotification]);
  console.log("notifications", notifications);

  const getNotificationsApi = async () => {
    setLoading(true);
    const response = await getNotifications({
      id: null,
      search: "",
      pageNumber: 1,
      pageSize: 10,
      showInactive: true,
      showUpcoming: true,
    });
    if (response?.data?.headers?.error === 200) {
      setNotifications(response?.data?.body?.items);
    } else {
      toast.error(response?.data?.headers?.message);
    }
    setLoading(false);
  };
  return (
    <>
      <header className={classes.header}>
        <div className={classes.titleContainer}>
          {link && (
            <span
              className={classes.leftPageIndicator}
              onClick={() => navigate(-1)}
            >
              <LeftPageIndicator />
            </span>
          )}
          <h1 className={classes.heading}>{title}</h1>
        </div>
        <nav className={classes.nav}>
          <div
            className={classes.bellIcon}
            onClick={() => setShowNotification(!showNotification)}
          >
            <BellIcon />
          </div>
          <span>
            <Menu
              model={items({ auth, navigate, setShowLogoutModal })}
              popup
              ref={menu}
              appendTo="self"
              className="w-full md:w-15rem"
              popupAlignment="right"
              style={{
                top: "75px",
                left: "530px",
              }}
            />
            <div className={classes.userInfoWrapper}>
              <div className={classes.content}>
                <span className={classes.userFrame}>
                  <img src={user} alt="user" />
                </span>
                <div className={classes.data}>
                  <h2>{auth?.name}</h2>
                  {/* <p>{auth?.userType}</p> */}
                </div>
              </div>
              <span
                className={classes.action}
                onClick={(e) => menu.current.toggle(e)}
              >
                <CheveronDown />
              </span>
            </div>
          </span>
        </nav>
      </header>

      {showNotification && (
        <>
          <div
            className={classes.overlay}
            onClick={handleCloseNotification}
          ></div>
          <div className={classes.notificationPopup}>
            <NotificationSection loading={loading} data={notifications} />
          </div>
        </>
      )}

      {showLogoutModal && (
        <LogoutModal
          show={showLogoutModal}
          setShow={setShowLogoutModal}
          onClick={logoutHandler}
          loading={loading}
        />
      )}
    </>
  );
};

export default Navbar;
